import Reveal from "./Reveal";
import { IMAGES } from "@/constants/site";

const FEATURES = [
  { icon: "ri-home-4-line", title: "Bungalov Konaklama", text: "A-frame bungalovlarda doğayla iç içe konforlu konaklama." },
  { icon: "ri-leaf-line", title: "Doğa & Akarsu", text: "Dağların ve akarsuyun çevrelediği sakin bir doğa ortamı." },
  { icon: "ri-restaurant-2-line", title: "Restaurant", text: "Sıcak ve samimi atmosferde lezzetli bir sofra deneyimi." },
  { icon: "ri-water-flash-line", title: "Yüzme Havuzu", text: "Dinlenmek için kapalı yüzme havuzu alanı." },
  { icon: "ri-fire-line", title: "Sauna", text: "Günün yorgunluğunu atabileceğiniz sıcak sauna." },
  { icon: "ri-drop-line", title: "Hamam", text: "Geleneksel Türk hamamı ile dinlendirici bir deneyim." },
  { icon: "ri-armchair-line", title: "Dinlenme Alanları", text: "Doğayla bütünleşmiş huzurlu dinlenme alanları." },
];

export default function ExperienceFeatures() {
  return (
    <section id="deneyim" className="w-full">
      {/* Immersive image band */}
      <div className="relative w-full h-[360px] md:h-[440px] overflow-hidden">
        <img
          src={IMAGES.mezzanine}
          alt="Düzbağ Life bungalov asma kat ve ahşap merdiven"
          title="doğa içinde bungalov deneyimi"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/45 to-foreground-950/30" />
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-7xl mx-auto w-full px-4 md:px-8 lg:px-12 pb-10 md:pb-14">
            <Reveal>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 font-medium leading-tight">
                BURADA SADECE KONAKLAMIYORSUNUZ
              </h2>
              <p className="mt-4 text-background-200 text-sm md:text-base max-w-2xl">
                Düzbağ Life, konaklamayı farklı deneyimlerle tamamlayan bütüncül
                bir yaşam alanı sunuyor.
              </p>
            </Reveal>
          </div>
        </div>
      </div>

      {/* Feature cards */}
      <div className="bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-16 md:py-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
            {FEATURES.map((feature, index) => (
              <Reveal key={feature.title} delay={(index % 4) * 80}>
                <article className="h-full bg-background-50 rounded-lg p-6 border border-background-200">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className={`${feature.icon} text-xl`} />
                  </span>
                  <h3 className="mt-5 font-heading text-xl text-foreground-950 font-medium">
                    {feature.title}
                  </h3>
                  <p className="mt-2 text-foreground-600 text-sm leading-relaxed">
                    {feature.text}
                  </p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}